<template>
  <div>
    <CRow>
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span class="font-weight-bold h6"> <CIcon name="cil-badge"/> {{ $t('reportCc') }} </span>
          </CCardHeader>
          <CCardBody>


            <CRow>
              <CCol>
                <CDataTable
                    :table-filter="{label:''}"
                    :fields="fields"
                    :items="item"
                    :items-per-page="small ? 50 : 20"
                    :dark="dark"
                    :loading="loading"
                    pagination
                    :items-per-page-select="pages"
                    sorter
                >

                  <template #index="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                  </template>


                  <template #isGap="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)"> {{ item.isGap }}
                      {{ '( ' + ((item.isGap / item.total) * 100).toFixed(2) + '% )' }}
                    </td>
                  </template>

                  <template #isNoGap="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)"> {{ item.total - item.isGap }}
                      {{ '( ' + (((item.total - item.isGap) / item.total) * 100).toFixed(2) + '% )' }}
                    </td>
                  </template>

                  <template #member="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                     {{ item.total }}
                    </td>
                  </template>

                  <template #complete="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.complete }} {{ '( ' + (((item.complete) / item.total) * 100).toFixed(2) + '% )' }}
                    </td>
                  </template>

                  <template #total="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ ((item.isGap / item.total) * 100).toFixed(2) }}
                    </td>
                  </template>

                  <template #isMeets="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.isMeets }} {{ '( ' + (((item.isMeets) / item.total) * 100).toFixed(2) + '% )' }}
                    </td>
                  </template>

                  <template #isExceeding="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.isExceeding }} {{ '( ' + (((item.isExceeding) / item.total) * 100).toFixed(2) + '% )' }}
                    </td>
                  </template>

                  <template #action="{item,index}">
                    <td style="width: 140px">
                      <CRow>
                        <CCol class="text-center">
                          <CButton class="mr-1" v-c-tooltip.hover.click="'Info'" size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item,index)"  >
                            <CIcon name="cil-description"/>
                          </CButton>

                        </CCol>
                      </CRow>
                    </td>
                  </template>

                  <template #details="{item,index}">
                    <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
                      <CRow>
                        <CCol></CCol>
                        <CCol  col="6">
                          <CChartDoughnut
                              :datasets="onDataChart(item)"
                              :labels="['ไม่ผ่านความคาดหวัง', 'อยู่ในระดับความคาดหวัง', 'สูงกว่าความคาดหวัง']"
                          />
                        </CCol>
                        <CCol></CCol>
                      </CRow>
                    </CCollapse>
                  </template>



                </CDataTable>
              </CCol>
              <CCol col="12">
                <CDropdownDivider/>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import {CChartDoughnut} from '@coreui/vue-chartjs'

export default {
  components: {CChartDoughnut},
  name: "ReportCompetency",
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    item: {
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key: "title", label: "ประเภทสมรรถนะ"},
          {key: "member", label: "Total", _style: 'width:100px; text-align: center'},
          {key: "complete", label: "Complete", _style: 'width:100px; text-align: center'},
          {key: "isGap", label: " Gap found", _style: 'width:150px; text-align: center'},
          {key: "isNoGap", label: " No Gap", _style: 'width:150px; text-align: center'},
          {key: "isMeets", label: "Meets Expectations ", _style: 'width:150px; text-align: center'},
          // {key: "isWithin", label: "Within Expectations", _style: 'width:150px; text-align: center'},
          {key: "isExceeding", label: "Exceeds Expectations", _style: 'width:150px; text-align: center'},
          {key:"action", label: "#", _style: 'width:20px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,

    pages: {
      type: Object,
      default() {
        return {
          values: [10, 20, 50, 100]
        }
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
  },
  data() {
    return {
      collapseDuration: 0,

    }
  },
  methods:{
    onDataChart(item){
      return  [{
        backgroundColor: [
          '#DD1B16',
          '#41B883',
          '#00D8FF',
        ],
        data: [(((item.total - item.isGap) / item.total) * 100).toFixed(2), (((item.isMeets) / item.total) * 100).toFixed(2), (((item.isExceeding) / item.total) * 100).toFixed(2)]
      }]
    },

    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

      // this.$emit('info',item)
    },
  }
}
</script>

<style scoped>

</style>
